export default function Terms(){
  return (
    <main role="main">
      <section className="section">
        <h1 className="h1">Terms of Service</h1>
        <p className="muted">By using FieldShare you agree to these terms.</p>
        <ul>
          <li>No illegal, harmful, or infringing content.</li>
          <li>We may remove content that violates policy or law.</li>
          <li>You retain rights to your content; you grant us a license for processing/delivery.</li>
        </ul>
        <p>For questions: legal@your-domain.tld</p>
      </section>
    </main>
  )
}

